import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesome } from 'src/containers/Elements';

interface Props {
	selected: string;
	onClick: (val: string) => void;
}

export const ChooseIconStatisticCard: FC<Props> = ({ selected, onClick }) => {
	const { t } = useTranslation();

	const listIcon = [
		'home',
		'user',
		'users',
		'envelope',
		'camera',
		'heart',
		'star',
		'search',
		'shopping-cart',
		'phone',
		'lock',
		'globe',
		'industry',
		'earth-americas',
		'earth-europe',
		'comments',
		'cog',
		'trash',
		'music',
		'video',
		'map-marker',
		'calendar',
		'clock',
		'lightbulb',
		'wifi',
		'car',
		'plane',
		'train',
		'umbrella',
		'cloud',
		'sun',
		'moon',
		'tree',
		'leaf',
		'fire',
		'snowflake',
		'hammer',
		'wrench',
		'key',
		'paperclip',
		'pencil',
		'paint-brush',
		'cut',
		'folder',
		'file',
		'download',
		'upload',
		'print',
		'credit-card',
		'money-bill',
		'gift',
		'abacus',
		'acorn',
		'ad',
		'add',
		'address-book',
		'address-card',
		'adjust',
		'air-conditioner',
		'air-freshener',
		'alarm-plus',
		'alarm-snooze',
		'album',
		'album-circle-plus',
		'album-circle-user',
		'album-collection',
		'album-collection-circle-plus',
		'album-collection-circle-user',
		'alicorn',
		'alien',
		'alien-8bit',
		'alien-monster',
		'align-center',
		'align-justify',
		'align-left',
		'align-right',
		'align-slash',
		'allergies',
		'alt',
		'ambulance',
		'american-sign-language-interpreting',
		'amp-guitar',
		'ampersand',
		'analytics',
		'anchor',
		'anchor-circle-check',
		'anchor-circle-exclamation',
		'anchor-circle-xmark',
		'anchor-lock',
		'angel',
		'angle',
		'angle-90',
		'angle-double-down',
		'angle-double-left',
		'angle-double-right',
		'angle-double-up',
		'angle-down',
		'angle-left',
		'angle-right',
		'angle-up',
		'angles-down',
		'angles-left',
		'angles-right',
		'angles-up',
		'angles-up-down',
		'angry',
		'ankh',
		'apartment',
		'aperture',
		'apostrophe',
		'apple-alt',
		'apple-core',
		'apple-crate',
		'apple-whole',
		'archive',
		'archway',
		'area-chart',
		'arrow-alt-circle-down',
		'arrow-alt-circle-left',
		'arrow-alt-circle-right',
		'arrow-alt-circle-up',
		'arrow-alt-down',
		'arrow-alt-from-bottom',
		'arrow-alt-from-left',
		'arrow-alt-from-right',
		'arrow-alt-from-top',
		'arrow-alt-left',
		'arrow-alt-right',
		'arrow-alt-square-down',
		'arrow-alt-square-left',
		'arrow-alt-square-right',
		'arrow-alt-square-up',
		'arrow-alt-to-bottom',
		'arrow-alt-to-left',
		'arrow-alt-to-right',
		'arrow-alt-to-top',
		'arrow-alt-up',
		'arrow-circle-down',
		'arrow-circle-left',
		'arrow-circle-right',
		'arrow-circle-up',
		'arrow-down',
		'arrow-down-1-9',
		'arrow-down-9-1',
		'arrow-down-a-z',
		'arrow-down-arrow-up',
		'arrow-down-big-small',
		'arrow-down-from-arc',
		'arrow-down-from-dotted-line',
		'arrow-down-from-line',
		'arrow-down-left',
		'arrow-down-left-and-arrow-up-right-to-center',
		'arrow-down-long',
		'arrow-down-right',
		'arrow-down-short-wide',
		'arrow-down-small-big',
		'arrow-down-square-triangle',
		'arrow-down-to-arc',
		'arrow-down-to-bracket',
		'arrow-down-to-dotted-line',
		'arrow-down-to-line',
		'arrow-down-to-square',
		'arrow-down-triangle-square',
		'arrow-down-up-across-line',
		'arrow-down-up-lock',
		'arrow-down-wide-short',
		'arrow-down-z-a',
		'arrow-from-bottom',
		'arrow-from-left',
		'arrow-from-right',
		'arrow-from-top',
		'arrow-left',
		'arrow-left-from-arc',
		'arrow-left-from-line',
		'arrow-left-long',
		'arrow-left-long-to-line',
		'arrow-left-rotate',
		'arrow-left-to-arc',
		'arrow-left-to-line',
		'arrow-pointer',
		'arrow-progress',
		'arrow-right',
		'arrow-right-arrow-left',
		'arrow-right-from-arc',
		'arrow-right-from-bracket',
		'arrow-right-from-file',
		'arrow-right-from-line',
		'arrow-right-long',
		'arrow-right-long-to-line',
		'arrow-right-rotate',
		'arrow-right-to-arc',
		'arrow-right-to-bracket',
		'arrow-right-to-city',
		'arrow-right-to-file',
		'arrow-right-to-line',
		'arrow-rotate-back',
		'arrow-rotate-backward',
		'arrow-rotate-forward',
		'arrow-rotate-left',
		'arrow-rotate-right',
		'arrow-square-down',
		'arrow-square-left',
		'arrow-square-right',
		'arrow-square-up',
		'arrow-to-bottom',
		'arrow-to-left',
		'arrow-to-right',
		'arrow-to-top',
		'arrow-trend-down',
		'arrow-trend-up',
		'arrow-turn-down',
		'arrow-turn-down-left',
		'arrow-turn-down-right',
		'arrow-turn-right',
		'arrow-turn-up',
		'arrow-up',
		'arrow-up-1-9',
		'arrow-up-9-1',
		'arrow-up-a-z',
		'arrow-up-arrow-down',
		'arrow-up-big-small',
		'arrow-up-from-arc',
		'arrow-up-from-bracket',
		'arrow-up-from-dotted-line',
		'arrow-up-from-ground-water',
		'arrow-up-from-line',
		'arrow-up-from-square',
		'arrow-up-from-water-pump',
		'arrow-up-left',
		'arrow-up-left-from-circle',
		'arrow-up-long',
		'arrow-up-right',
		'arrow-up-right-and-arrow-down-left-from-center',
		'arrow-up-right-dots',
		'arrow-up-right-from-square',
		'arrow-up-short-wide',
		'arrow-up-small-big',
		'arrow-up-square-triangle',
		'arrow-up-to-arc',
		'arrow-up-to-dotted-line',
		'arrow-up-to-line',
		'arrow-up-triangle-square',
		'arrow-up-wide-short',
		'arrow-up-z-a',
		'arrows',
		'arrows-alt',
		'arrows-alt-h',
		'arrows-alt-v',
		'arrows-cross',
		'arrows-down-to-line',
		'arrows-down-to-people',
		'arrows-from-dotted-line',
		'arrows-from-line',
		'arrows-h',
		'arrows-left-right',
		'arrows-left-right-to-line',
		'arrows-maximize',
		'arrows-minimize',
		'arrows-repeat',
		'arrows-repeat-1',
		'arrows-retweet',
		'arrows-rotate',
		'arrows-spin',
		'arrows-split-up-and-left',
		'arrows-to-circle',
		'arrows-to-dot',
		'arrows-to-dotted-line',
		'arrows-to-eye',
		'arrows-to-line',
		'arrows-turn-right',
		'arrows-turn-to-dots',
		'arrows-up-down',
		'arrows-up-down-left-right',
		'arrows-up-to-line',
		'arrows-v',
		'asl-interpreting',
		'assistive-listening-systems',
		'asterisk',
		'at',
		'atlas',
		'atom',
		'atom-alt',
		'atom-simple',
		'audio-description',
		'audio-description-slash',
		'austral-sign',
		'automobile',
		'avocado',
		'award',
		'award-simple',
		'axe',
		'axe-battle',
		'b',
		'baby',
		'baby-carriage',
		'backpack',
		'backspace',
		'backward',
		'backward-fast',
		'backward-step',
		'bacon',
		'bacteria',
		'bacterium',
		'badge',
		'badge-check',
		'badge-dollar',
		'badge-percent',
		'badge-sheriff',
		'badger-honey',
		'badminton',
		'bag-seedling',
		'bag-shopping',
		'bagel',
		'bags-shopping',
		'baguette',
		'bahai',
		'baht-sign',
		'balance-scale',
		'balance-scale-left',
		'balance-scale-right',
		'ball-pile',
		'balloon',
		'balloons',
		'ballot',
		'ballot-check',
		'ban',
		'ban-bug',
		'ban-parking',
		'ban-smoking',
		'banana',
		'band-aid',
		'bandage',
		'bangladeshi-taka-sign',
		'banjo',
		'bank',
		'bar-chart',
		'barcode',
		'barcode-alt',
		'barcode-read',
		'barcode-scan',
		'barn-silo',
		'bars',
		'bars-filter',
		'bars-progress',
		'bars-sort',
		'bars-staggered',
		'baseball',
		'baseball-ball',
		'baseball-bat-ball',
		'basket-shopping',
		'basket-shopping-simple',
		'basketball',
		'basketball-ball',
		'basketball-hoop',
		'bat',
		'bath',
		'bathtub',
		'battery',
		'battery-0',
		'battery-1',
		'battery-2',
		'battery-3',
		'battery-4',
		'battery-5',
		'battery-bolt',
		'battery-car',
		'battery-empty',
		'battery-exclamation',
		'battery-full',
		'battery-half',
		'battery-low',
		'battery-quarter',
		'battery-slash',
		'battery-three-quarters',
		'bed',
		'bed-alt',
		'bed-bunk',
		'bed-empty',
		'bed-front',
		'bed-pulse',
		'bee',
		'beer',
		'beer-foam',
		'beer-mug',
		'beer-mug-empty',
		'bell',
		'bell-concierge',
		'bell-exclamation',
		'bell-on',
		'bell-plus',
		'bell-school',
		'bell-school-slash',
		'bell-slash',
		'bells',
		'bench-tree',
		'betamax',
		'bezier-curve',
		'bible',
		'bicycle',
		'biking',
		'biking-mountain',
		'billboard',
		'bin-bottles',
		'bin-bottles-recycle',
		'bin-recycle',
		'binary',
		'binary-circle-check',
		'binary-lock',
		'binary-slash',
		'binoculars',
		'biohazard',
		'bird',
		'birthday-cake',
		'bitcoin-sign',
		'blackboard',
		'blanket',
		'blanket-fire',
		'blender',
		'blender-phone',
		'blind',
		'blinds',
		'blinds-open',
		'blinds-raised',
		'block',
		'block-brick',
		'block-brick-fire',
		'block-question',
		'block-quote',
		'blog',
		'blueberries',
		'bluetooth',
		'bold',
		'bolt',
		'bolt-auto',
		'bolt-lightning',
		'bolt-slash',
		'bomb',
		'bone',
		'bone-break',
		'bong',
		'book',
		'book-alt',
		'book-arrow-right',
		'book-arrow-up',
		'book-atlas',
		'book-bible',
		'book-blank',
		'book-bookmark',
		'book-circle',
		'book-circle-arrow-right',
		'book-circle-arrow-up',
		'book-copy',
		'book-dead',
		'book-font',
		'book-heart',
		'book-journal-whills',
		'book-law',
		'book-medical',
		'book-open',
		'book-open-alt',
		'book-open-cover',
		'book-open-reader',
		'book-quran',
		'book-reader',
		'book-section',
		'book-skull',
		'book-sparkles',
		'book-spells',
		'book-tanakh',
		'book-user',
		'bookmark',
		'bookmark-circle',
		'bookmark-slash',
		'books',
		'books-medical',
		'boombox',
		'boot',
		'boot-heeled',
		'booth-curtain',
		'border-all',
		'border-bottom',
		'border-bottom-right',
		'border-center-h',
		'border-center-v',
		'border-inner',
		'border-left',
		'border-none',
		'border-outer',
		'border-right',
		'border-style',
		'border-style-alt',
		'border-top',
		'border-top-left',
		'bore-hole',
		'bottle-droplet',
		'bottle-water',
		'bow-arrow',
		'bowl-chopsticks',
		'bowl-chopsticks-noodles',
		'bowl-food',
		'bowl-hot',
		'bowl-rice',
		'bowl-salad',
		'bowl-scoop',
		'bowl-scoops',
		'bowl-shaved-ice',
		'bowl-soft-serve',
		'bowl-spoon',
		'bowling-ball',
		'bowling-ball-pin',
		'bowling-pins',
		'box',
		'box-alt',
		'box-archive',
		'box-ballot',
		'box-check',
		'box-circle-check',
		'box-dollar',
		'box-fragile',
		'box-full',
		'box-heart',
		'box-open'
	];
	const [icons, setIcons] = useState(listIcon);

	function filterIcons(query) {
		setIcons(listIcon.filter((icon) => icon.includes(query)));
	}

	return (
		<div className="p-4">
			<input
				type="text"
				id="title"
				placeholder={t('placeholder.search')}
				className="inputbox w-100 mb-3"
				onChange={(e) => {
					filterIcons(e.target.value);
				}}
			/>

			<div
				className="d-flex flex-wrap gap-2"
				style={{ height: '200px', overflowY: 'auto' }}>
				{icons?.map((icon) => {
					return (
						<div
							key={icon}
							onClick={() => {
								onClick(icon);
							}}
							className="border p-2 d-flex justify-content-center align-items-center"
							style={{
								borderRadius: '8px',
								width: '52px',
								height: '52px',
								cursor: 'pointer'
							}}>
							<FontAwesome
								icon={icon as string}
								size="lg"
								className={
									selected === icon
										? 'text-primary'
										: 'text-black'
								}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};
